export enum APP_ROUTES {
  welcome = 'welcome',
  personalDetails = 'personal-details',
  consent = 'consent',
  openBankingConsent = 'open-banking-consent',
  workReportConsent = 'work-report-consent',
  advancedEligibilityConsent = 'advanced-eligibility-consent',
  employmentDetails = 'employment-details',
  employmentVerification = 'employment-verification',
  bankList = 'bank-list',
  accounts = 'account-list',
  accountConnected = 'account-connected',
  transactions = 'fetch-transactions',
  accountCheck = 'account-check',
  thankYou = 'thank-you',
  timeout = 'timeout',
  passport = 'passport',
  cookiePolicy = 'cookie-policy',
  error = 'error',
  revoke = 'revoke',
  idDocVerification = 'id-doc-verification',
  journeyTracker = 'journey-tracker',
  privacyPolicy = 'privacy-policy',
  terms = 'terms',
  recatSummary = 'transaction-recat-summary',
  fixMyTransactions = 'fix-my-transactions',
  editTransactionRecategorisation = 'edit-transaction-recategorisation',
  reviewSelectCategory = 'review-select-category',
  appRedirect = 'app-redirect',
  recategorisationSuccessful = 'recategorisation-successful',
  transactionMoved = 'transaction-moved',
  transactionRecategorisationAllDone = 'transaction-recategorisation-all-done',
  howItWorks = 'how-it-works',
  idConnectRedirect = 'idconnectredirect',
}
